module.exports = __webpack_public_path__ + "static/media/f96020a07eee1760bc0b766a81df4675.5aecc606.png";